import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaYoutube = props => {
  if (props.id !== "_svgsocialmediayoutube") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 4c8.837 0 16 7.164 16 16 0 8.837-7.163 16-16 16S4 28.837 4 20c0-8.836 7.163-16 16-16zm.297 9.232h-.594c-.975.004-4.182.03-6.442.193-.376.046-1.196.048-1.928.816-.577.584-.765 1.91-.765 1.91s-.193 1.558-.193 3.116v1.461c0 1.557.193 3.115.193 3.115s.188 1.326.765 1.91c.732.767 1.695.743 2.123.824 1.437.136 5.892.186 6.48.192h.255c.83-.004 4.201-.03 6.548-.2.376-.044 1.196-.049 1.928-.816.578-.584.765-1.91.765-1.91s.193-1.558.193-3.115v-1.461c0-1.558-.193-3.115-.193-3.115s-.187-1.327-.765-1.91c-.732-.769-1.552-.77-1.928-.817-2.26-.162-5.466-.189-6.442-.193zm-2.582 3.57l5.2 2.713-5.2 2.693v-5.407z" fill="#202020" /></svg>;
};

SvgSocialmediaYoutube.displayName = "_svgsocialmediayoutube";
SvgSocialmediaYoutube.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaYoutube.defaultProps = {
  id: ''
};
export default SvgSocialmediaYoutube;